<button
  type="{{ type }}"
  class="btn {{ classCss }}"
  (click)="returnEmitter()">
  {{ text | translatePipe }}
</button>
